const state = {
  isLoading: false,
};

export const mutations = {
  setLoading(state, payload) {
    state.isLoading = payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
